import React from 'react';
import ReactDOM from 'react-dom/client';
import {SENTRY_CONFIG} from './config/Sentry';
import App from './App';
import * as Sentry from '@sentry/react';
import './index.css';

Sentry.init(SENTRY_CONFIG);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);